<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>拼团管理>创建拼团</div>
		<div class="newADcontent">
			<div class="adContent">
				<p style="font-size: 14px;margin-top: 10px;"><span
						style="color: red;">*</span>提示：拼团一旦开始则不能更改上述信息，仅可延长结束时间和开启/关闭模拟成团</p>
				<div class="title" style="margin-top: 20px;">
					<div class="blue"></div>
					<div style="flex: 1;">基本设置</div>
				</div>
				<el-form ref="form" :model="addDataList" label-width="150px" label-position="left">
					<el-form-item label="拼团券">
						<el-button @click="addquan" type="text" style="color: #999;"><i
								class="el-icon-plus"></i>添加券</el-button>
					</el-form-item>
					<el-form-item label="商品原价">
						<el-input type="text" size="small" style="width: 200px;margin-right: 10px;"></el-input>元
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">拼团信息</div>
					</div>
					<el-form-item label="拼团时间">
						<el-date-picker size="small" v-model="addDataList.time" type="datetimerange"
							format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="拼团人数">
						<el-input v-model="addDataList.count" style="width: 300px;" size="small"
							placeholder="输入拼团人数"></el-input>
						<p style="font-size: 12px;color: #999;">包括团长在内的人数，建议2-10人内</p>
					</el-form-item>
					<el-form-item label="拼团时限">
						<p>
							<el-radio v-model="addDataList.timeLimit" label="1">24小时</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.timeLimit" label="2">48小时</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.timeLimit" label="3">自定义</el-radio>
							<el-select style="width: 100px;margin:0 20px;" size="small"
								v-model="addDataList.timeLimitCount">
								<el-option v-for="item in addDataList.timeLimitCountList" :key="item.value"
									:label="item.label" :value="item.value">
								</el-option>
							</el-select>
						</p>
						<p style="font-size: 12px; color: #999;">在此期限内如果拼团不成功自动退款（如果活动剩余时间少于拼团时限以活动剩余时间为准）</p>
					</el-form-item>
					<el-form-item label="团员价格">
						<el-input v-model="addDataList.count" style="width: 200px;margin-right: 10px;" size="small"
							placeholder="请输入价格"></el-input>元
						<el-input v-model="addDataList.count" style="width: 200px;margin-right: 10px;margin-left: 50px;"
							size="small" placeholder="请输入积分"></el-input>积分
						<p style="font-size: 12px;color: #999;">拼团价格设置不得高于原价，且不得为0</p>
					</el-form-item>
					<el-form-item label="团长价格">
						<el-input v-model="addDataList.count" style="width: 200px;margin-right: 10px;" size="small"
							placeholder="请输入价格"></el-input>元
						<el-input v-model="addDataList.count" style="width: 200px;margin-right: 10px;margin-left: 50px;"
							size="small" placeholder="请输入积分"></el-input>积分
						<p style="font-size: 12px;color: #999;">团长价格与团员价格差距过大，会存在"虚假拼团"的风险（微信官方封杀）</p>
					</el-form-item>
					<el-form-item label="模拟成团">
						<p>
							<el-radio v-model="addDataList.legalRight" label="1">开启</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.legalRight" label="2">关闭</el-radio>
						</p>
						<p style="font-size: 12px;color: #999;width: 70%;line-height: 20px;">
							开启模拟成团，当拼团时限或拼团活动结束前，人数未满的团，系统将会模拟“匿名”买家凑满人数，使其成团。注意：模拟成团的团长也可以享受团长价格，请谨慎设置 </p>
					</el-form-item>
					<el-form-item label="超员成团">
						<p>
							<el-radio v-model="addDataList.legalRight" label="1">开启</el-radio>
						</p>
						<p>
							<el-radio v-model="addDataList.legalRight" label="2">关闭</el-radio>
						</p>
						<p style="font-size: 12px;color: #999;width: 70%;line-height: 20px;">
							开启超员成团后，拼团人数为最低成团人数。即：如果同时参与某个团的人数超过拼团人数，那么将以实际参团的人数成团，避免超员用户支付</p>
					</el-form-item>
					<div class="title" style="margin-top: 20px;">
						<div class="blue"></div>
						<div style="flex: 1;">分享设置</div>
					</div>
					<el-form-item label="分享标题">
						<el-input v-model="addDataList.title" size="small" style="width: 500px;" maxlength="24"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="分享描述">
						<el-input v-model="addDataList.describe" size="small" style="width: 500px;" maxlength="36"
							show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="分享图片">
						<div style="display: flex;">
							<div style="width: 130px; height: 130px">
								<el-image style="width: 130px; height: 130px" :src="addDataList.img" fit="fill">
									<div slot="error" class="image-slot">
										<img src="../../../assets/sa.png" />
									</div>
								</el-image>
							</div>
							<div style="width: 130px; height: 130px;margin-left: 20px;">
								<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
									:show-file-list="false">
									<el-button type="primary" size="small">选择图片</el-button>
								</el-upload>
								<p style="color: red;font-size: 12px;line-height: 20px;margin-top: 10px;">
									图片格式为：bmp，jpeg，jpg，gif，尺寸1:1，不可大于1M。</p>
							</div>
						</div>
					</el-form-item>
					<el-form-item>
						<el-button>取消</el-button>
						<el-button type="primary" style="margin-left: 20px;">保存</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div <!-- 添加券 -->
		<el-dialog title="添加券/券包" :visible.sync="addquan" width="70%">
			<el-input v-model="serchQ" size="small" style="width: 200px;" placeholder="输入门店名称"></el-input>
			<el-button type="primary" style="margin-left: 20px;" size="small">筛选</el-button>
			<div style="margin-top: 20px;">
				<el-radio-group v-model="dataState" size="small">
					<el-radio-button label="券"></el-radio-button>
					<el-radio-button label="券包"></el-radio-button>
				</el-radio-group>
			</div>
			<div class="tabelContent" style="margin-top: 20px;">
				<el-checkbox-group v-model="dataCheck">
					<el-table :data="dataList" style="width: 100%">
						<el-table-column align="center" width="100" label="选择">
							<template slot-scope="scope">
								<el-checkbox :label="scope.row.name1"></el-checkbox>
							</template>
						</el-table-column>
						<el-table-column label="券名称" prop="name2" align="center"></el-table-column>
						<el-table-column prop="name3" align="center" label="试用范围"></el-table-column>
						<el-table-column prop="name4" align="center" label="券内容"></el-table-column>
						<el-table-column align="center" label="有效期">
							<template slot-scope="scope">
								至{{scope.row.name5 || 0}}
							</template>
						</el-table-column>
						<el-table-column align="center" label="已领取/优惠券总量">
							<template slot-scope="scope">
								{{scope.row.name6 || 0}}/{{scope.row.name7 || 0}}
							</template>
						</el-table-column>
						<el-table-column align="center" prop="name8" label="已使用">
						</el-table-column>
					</el-table>
				</el-checkbox-group>
				<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
					:page-size="10" :total="80">
				</el-pagination>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				addDataList: {
					time: "",
					count: "",
					legalRight: "",
					timeLimit: "",
					timeLimitCountList: [{
						value: "30",
						label: "30分钟"
					}, {
						value: "60",
						label: "30分钟"
					}, {
						value: "120",
						label: "2个小时"
					}],
					title: "",
					describe: "",
					img: ""
				},
				addquan: false,
				serchQ: "",
				dataState: "券",
				dataList: [{
					name1: "1",
					name2: "剪发5元优惠券",
					name3: "全部门店",
					name4: "满100-50",
					name5: "2020-08-17 20:00",
					name6: 80,
					name7: 200,
					name8: 15
				}],
			}
		}
	}
</script>

<style lang="less" scoped>
	p {
		margin: 0;
		padding: 0;
	}

	.title {
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
		display: flex;
		font-weight: bold;
		margin-bottom: 10px;

		.blue {
			width: 5px;
			height: 15px;
			background: #409EFF;
			border-radius: 2px;
			margin-right: 8px;
			position: relative;
			top: 4px;
		}
	}

	.newADcontent {
		display: flex;

		// & > div{
		// 	display: inline-block;
		// }
		.adContent {
			flex: 2;
		}

		.adExamples {
			flex: 1;
			padding: 0 30px;

			img {
				width: 300px;
				height: auto;
			}
		}
	}
</style>